/**
 * Gera senha aleatória usando CSPRNG (crypto.getRandomValues).
 *
 * <p>Garante por construção: pelo menos 1 letra maiúscula + 1 número
 * (atende ao regex `^(?=.*[A-Za-z])(?=.*\d).+$` da policy backend).</p>
 *
 * <p>Alfabeto exclui caracteres ambíguos (I, O, l, 0, 1) pra reduzir erro
 * de transcrição quando o operador anota e dita pro usuário.</p>
 *
 * <p>NÃO usar `Math.random()` — não é criptograficamente seguro e fica
 * previsível em janelas curtas; `crypto.getRandomValues()` é o equivalente
 * browser do RNGCryptoServiceProvider/RandomNumberGenerator do .NET.</p>
 */
export function gerarSenhaSegura(length: number = 12): string {
  if (length < 4) throw new Error('Comprimento mínimo é 4 (pra garantir letra+número).');

  const letrasMaiusc = 'ABCDEFGHJKLMNPQRSTUVWXYZ'; // sem I, O
  const letrasMinusc = 'abcdefghjkmnpqrstuvwxyz';   // sem i, l, o
  const numeros = '23456789';                        // sem 0, 1
  const todos = letrasMaiusc + letrasMinusc + numeros;

  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  const chars: string[] = [];

  chars.push(letrasMaiusc[bytes[0] % letrasMaiusc.length]);
  chars.push(numeros[bytes[1] % numeros.length]);
  for (let i = 2; i < length; i++) {
    chars.push(todos[bytes[i] % todos.length]);
  }

  const shuffle = new Uint8Array(length);
  crypto.getRandomValues(shuffle);
  for (let i = length - 1; i > 0; i--) {
    const j = shuffle[i] % (i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }

  return chars.join('');
}
